import _ from 'underscore';
import { DiagnosticsTypes } from '@bingads-webui-campaign-react/summary-diagnostic';
import { ScenarioMap } from './constants';

export const extractAuditPoints = (dataArray) => {
  const issueList = [];
  const recommendList = [];

  if (!dataArray) return { issueList, recommendList };

  dataArray.forEach((item) => {
    const { Key, Value } = item;
    const { Status, AuditPoints } = Value;

    const scenario = _.get(ScenarioMap, [Key, Status]);
    if (!scenario) return;

    AuditPoints.forEach((auditPoint) => {
      const auditDetails = scenario[auditPoint];
      if (auditDetails) {
        if (auditDetails.type === DiagnosticsTypes.Issue) {
          issueList.push(auditDetails);
        } else if (auditDetails.type === DiagnosticsTypes.Recommendation) {
          recommendList.push(auditDetails);
        }
      }
    });
  });

  return { issueList, recommendList };
};

export const convertDiagnosticsDataToTrackingLog = (diagnosticsData) => {
  let msg = '';
  if (!diagnosticsData) return msg;

  const auditCheckList = [];
  diagnosticsData.forEach((item) => {
    const { Key, Value } = item;
    const { Status, AuditPoints } = Value;
    const scenario = _.get(ScenarioMap, [Key, Status]);
    if (!scenario) return;

    AuditPoints.forEach((auditPoint) => {
      const auditDetails = scenario[auditPoint];
      if (auditDetails) {
        auditCheckList.push(auditPoint);
      }
    });
  });
  msg += `@auditCheckCount=${auditCheckList.length};`;
  msg += `@auditCheckList=${auditCheckList.join(',')};`;

  return msg;
};
